import React from 'react';
import TextInput from '../shared/TextInput';
import Textarea from '../shared/Textarea';
import Button from '../shared/Button';
import './StageThree.css';

const StageThree = ({ formData, setFormData, onBack, onSubmit, isSubmitting }) => {
  const [errors, setErrors] = React.useState({});

  const handleStakeChange = (e) => {
    const value = e.target.value;
    // Allow only numbers and decimal point
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setFormData({
        ...formData,
        stake: {
          ...formData.stake,
          amount: value
        }
      });
      setErrors({ ...errors, amount: null });
    }
  };

  const handleNoteChange = (e) => {
    setFormData({
      ...formData,
      stake: {
        ...formData.stake,
        note: e.target.value
      }
    });
  };

  const validate = () => {
    const newErrors = {};
    const amount = parseFloat(formData.stake.amount);

    if (!formData.stake.amount || isNaN(amount) || amount <= 0) {
      newErrors.amount = 'Please enter a valid stake amount';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      // Convert amount to number before submitting
      const submitData = {
        ...formData,
        stake: {
          amount: parseFloat(formData.stake.amount),
          currency: 'USD',
          note: formData.stake.note || undefined
        }
      };
      onSubmit(submitData);
    }
  };

  return (
    <div className="stage-three">
      <p className="stage-three__prompt">How confident are you?</p>

      <div className="stage-three__stake-input">
        <span className="stage-three__currency">$</span>
        <TextInput
          label="Stake Amount"
          value={formData.stake.amount}
          onChange={handleStakeChange}
          placeholder="0.00"
          type="text"
          required
          error={errors.amount}
        />
      </div>

      <Textarea
        label="Optional: Add note about confidence"
        value={formData.stake.note || ''}
        onChange={handleNoteChange}
        placeholder="Why this stake amount? What factors give you confidence?"
        maxLength={300}
        showCounter
        rows={4}
      />

      <div className="stage-three__actions">
        <Button onClick={onBack} variant="secondary" disabled={isSubmitting}>
          ← Back
        </Button>
        <Button onClick={handleSubmit} variant="primary" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit Belief'}
        </Button>
      </div>
    </div>
  );
};

export default StageThree;
